// import { createTheme } from '@mui/material/styles';

// import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
// import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

// const theme = createTheme({
// 	breakpoints: breakpoints,
// 	mixins: mixins,
// });

export const styles = {};

export const overrides = {
	'.EventsCategoryList-section': {
		paddingBottom: remCalc(60),
	},
	'.eventCategory__media': {
		position: 'absolute',
		inset: 0,
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
		transition: 'transform .35s ease',
	},

	'.eventCategory__overlay': {
		position: 'absolute',
		inset: 0,
		background: 'rgba(0, 0, 0, 0.3)',
		transition: 'background-color .2s',
	},

	'.eventCategory__actionArea': {
		position: 'relative',
		zIndex: 1,
		height: '100%',
		display: 'flex',
		alignItems: 'flex-end',
		textDecoration: 'none',
		color: getColor('white'),

		'&:hover': {
			textDecoration: 'none',
		},

		'&:focus-visible': {
			outline: `${remCalc(2)} solid ${getColor('blue', 400)}`,
			outlineOffset: `-${remCalc(2)}`,
		},
	},

	'.eventCategory__content': {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',
		gap: remCalc(20),
		padding: remCalc(48),
		height: '100%',
		transition: 'gap .35s ease',
	},

	'.eventCategory__cardSubtitle': {
		color: getColor('white'),
		margin: 0,
		maxHeight: remCalc(32),
		overflow: 'hidden',
		opacity: 1,
		transform: 'translateY(0)',
		letterSpacing: remCalc(-0.25),
		textTransform: 'uppercase',
		transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease',
	},

	'.eventCategory__cardTitle': {
		color: getColor('white'),
		margin: 0,
		letterSpacing: remCalc(0.5),
		textTransform: 'capitalize',
		transition: 'font-size var(--transition-duration) ease, line-height var(--transition-duration) ease, letter-spacing var(--transition-duration) ease',
	},
	'.eventCategory__card--event': {
		position: 'relative',
		height: remCalc(309),
		borderRadius: 0,
		overflow: 'hidden',
		boxShadow: 'none',
		backgroundColor: getColor('white', 400),
		'.eventCategory__content': {
			color: getColor('ivory', 700),
		},
		'.eventCategory__cardSubtitle': {
			color: getColor('ivory', 700),
		},
		'.eventCategory__cardTitle': {
			color: getColor('ivory', 700),
			fontSize: remCalc(32),
			lineHeight: remCalc(40),
		},
		'.eventCategory__cardIconRow': {
			display: 'flex',
			flexDirection: 'row',
			gap: remCalc(10),
			alignItems: 'center',
			transition: 'opacity var(--transition-duration) ease, transform var(--transition-duration) ease, max-height var(--transition-duration) ease',
		},
		'.eventCategory__cardIcon': {
			width: remCalc(14),
			'&.locationPin': {
				width: 'unset',
				height: remCalc(16),
				flex: 'auto 0 0'
			}
		},
		'.eventCategory__overlay': {
			display: 'none',
		},
		'&:focus-within': {
			backgroundColor: getColor('ivory', 400),
			'.eventCategory__media': {
				transform: 'scale(1.22)',
			},
			'.eventCategory__overlay': {
				background: 'rgba(0, 0, 0, 0.2)',
			},
			'.eventCategory__content': {
				gap: 0,
			},
			'.eventCategory__cardSubtitle': {
				opacity: 0,
				maxHeight: 0,
				transform: 'translateY(-8px)',
			},
			'.eventCategory__cardTitle': {
				fontSize: remCalc(39),
				lineHeight: remCalc(47),
				letterSpacing: remCalc(0.5),
			},
			'.eventCategory__cardIconRow': {
				opacity: 0,
				maxHeight: 0,
				transform: 'translateY(-8px)',
			},
		},
		'@media (hover: hover) and (pointer: fine)': {
			'&:hover': {
				backgroundColor: getColor('ivory', 400),
				'.eventCategory__media': {
					transform: 'scale(1.22)',
				},
				'.eventCategory__overlay': {
					background: 'rgba(0, 0, 0, 0.2)',
				},
				'.eventCategory__content': {
					gap: 0,
				},
				'.eventCategory__cardSubtitle': {
					opacity: 0,
					maxHeight: 0,
					transform: 'translateY(-8px)',
				},
				'.eventCategory__cardIconRow': {
					opacity: 0,
					maxHeight: 0,
					transform: 'translateY(-8px)',
				},
				'.eventCategory__cardTitle': {
					fontSize: remCalc(39),
					lineHeight: remCalc(47),
					letterSpacing: remCalc(0.5),
				},
			},
		},
	},
};

export default styles;